var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pagination"
  }, [_c('ul', {
    staticClass: "pager clear",
    on: {
      "click": _vm.onPage
    }
  }, [_c('li', {
    staticClass: "pn prev",
    class: {
      disabled: _vm.page <= 1
    },
    attrs: {
      "aria-disabled": _vm.page <= 1,
      "arial-label": _vm.arialLabel(-1),
      "tabindex": "0",
      "data-page": "-1",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "arrow"
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-arrow"
    }
  })], 1)]), _vm._l(_vm.slices, function (group, index) {
    return [group[0] === -1 ? _c('li', {
      key: 'g' + index,
      staticClass: "pn jumper",
      attrs: {
        "data-page": group[1],
        "data-jumper": index,
        "arial-label": _vm.arialLabel(group[1])
      }
    }, [_c('span', {
      staticClass: "dots"
    }, [_vm._v("...")])]) : _vm._l(group, function (i) {
      return _c('li', {
        key: 'l' + i,
        staticClass: "pn",
        class: {
          active: _vm.page === i
        },
        attrs: {
          "data-page": i,
          "arial-label": _vm.arialLabel(i),
          "role": "button"
        }
      }, [_c('span', [_vm._v(_vm._s(i))])]);
    })];
  }), _c('li', {
    staticClass: "pn next",
    class: {
      disabled: _vm.page >= _vm.pages
    },
    attrs: {
      "aria-disabled": _vm.page >= _vm.pages,
      "arial-label": _vm.arialLabel(0),
      "tabindex": "0",
      "data-page": "0",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "arrow"
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-arrow"
    }
  })], 1)])], 2), _vm.showSizes ? _c('div', {
    staticClass: "page-size"
  }, [_c('div', {
    staticClass: "page-select",
    on: {
      "mouseenter": function ($event) {
        _vm.showPageList = true;
      },
      "mouseleave": function ($event) {
        _vm.showPageList = false;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.pageSize) + " "), _vm.showPageList ? _c('div', {
    staticClass: "select-box"
  }, _vm._l(_vm.pageSizeList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "seleclt-opotion",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.onSize(item);
        }
      }
    }, [_vm._v(_vm._s(item))]);
  }), 0) : _vm._e()])]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };